import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-y-1" }

import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import { computed, ref } from 'vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { getFormInput } from '@/utils/form-input-helper';
import ActionBar from '@/components/ActionBar/ActionBar.vue';
import { useAccountStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberBenefitsHeader',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

const accountStore = useAccountStore();
const actionBarContent = getFormInput(props.content, 'actionBar');

const membershipLoyaltyLevel = ref<string>(accountStore.identityDetails?.membershipLoyalty ?? '');

const actionBarButtons = computed(() => {
  actionBarContent.fields[0].link!.value!.text = `${membershipLoyaltyLevel.value} benefits`;
  return actionBarContent;
});

const onClick_ActionBarButton = async (linkItem: any) => {
  const memberBenefits = document.getElementById('memberBenefits');
  if (memberBenefits) {
    memberBenefits.scrollIntoView({ behavior: 'smooth' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FormStepInputs, {
      step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
    }, {
      memberBenefitsPanelTitle: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_unref(getFormInput)(props.content, 'memberBenefitsPanelTitle'))), null, 16)
        ])
      ]),
      actionBar: _withCtx(() => [
        (actionBarButtons.value)
          ? (_openBlock(), _createBlock(ActionBar, _mergeProps({ key: 0 }, actionBarButtons.value, {
              outerClass: _unref(actionBarContent).outerClass,
              innerClass: _unref(actionBarContent).innerClass,
              handleLinkClickEvent: true,
              onBtnClick: _cache[0] || (_cache[0] = (linkName) => onClick_ActionBarButton(linkName))
            }), null, 16, ["outerClass", "innerClass"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["step"])
  ]))
}
}

})